import React from 'react';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {bindActionCreators} from "redux";
import {clearFilter, stopAirportSelected, stopAirportsFilterShowMore} from "../../actions/FlightsActions";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";

const PAGE_SIZE = 10;

class ConnectionsBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'stopAirports';
        this.name = 'Airports connections';
        this.urlEnabled = props.urlFilters.stopAirports && props.urlFilters.stopAirports.length !== 0;
    }

    renderAirportList() {
        let list = [];

        const unordered = this.props.stopAirports;
        let ordered = {};
        Object.keys(unordered)
            .sort((a, b) => {
                return unordered[a].city.localeCompare(unordered[b].city)
            })
            .forEach(
                (key) => {
                    ordered[key] = unordered[key];
                }
            );

        for (const key of Object.keys(ordered)) {
            list.push(this.renderAirport(ordered[key]))
        }
        list = list.slice(0, this.props.page * PAGE_SIZE);

        return list;
    }

    selectAirport(code, e) {
        this.props.stopAirportSelected(code);
    }

    renderAirport(airport) {
        return (
            <div className="form-check" key={airport.code}>
                <label className="form-check-label">
                    <input
                        checked={this.props.selected.indexOf(airport.code) !== -1}
                        onChange={this.selectAirport.bind(this, airport.code)}
                        className="form-check-input" type="checkbox" value={airport.code}/>
                    <small>{airport.city} <small>{airport.title} {airport.code}</small></small>
                </label>
            </div>
        );
    }

    doRenderShowMore() {
        return Object.keys(this.props.stopAirports).length > this.props.page * PAGE_SIZE;
    }

    renderShowMore() {
        if (!this.doRenderShowMore()) {
            return null;
        }

        return (
            <button className="btn btn-link show-more-link" onClick={this.showMore.bind(this)}>
                <small>{this.translator.trans('Show more')}...</small>
            </button>
        );
    }

    showMore() {
        this.props.stopAirportsFilterShowMore();
    }

    render() {
        if (Object.keys(this.props.stopAirports).length <= 1) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold mb-2">{this.translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    {this.renderAirportList()}
                    {this.renderShowMore()}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        stopAirportSelected,
        stopAirportsFilterShowMore,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        stopAirports: state.StopAirportsFilterReducer.airports,
        page: state.StopAirportsFilterReducer.page,
        selected: state.StopAirportsFilterReducer.selected,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionsBlock);



// WEBPACK FOOTER //
// ./src/components/filters/ConnectionsBlock.js